<template>
    <div class="moneybag-page">
        <header class="top-nav">
            <button type="button" class="back-btn" @click="$router.back()">
                <van-icon name="arrow-left" />
            </button>
            <h1 class="nav-title">{{ mainTab === "income" ? getLabel('pageMoneybag.titleIncome', 'Registros de Ingresos') : getLabel('pageMoneybag.titleExpense', 'Registros de Gastos') }}</h1>
        </header>

        <main class="page-content">
            <!-- 主切换：Ingresos / Gastos -->
            <nav class="main-toggle">
                <button
                    type="button"
                    class="toggle-btn income"
                    :class="{ active: mainTab === 'income' }"
                    @click="mainTab = 'income'; subTab = 'all'"
                >
                    <van-icon name="arrow-up" />
                    {{ getLabel('pageMoneybag.incomeTab', 'Ingresos') }}
                </button>
                <button
                    type="button"
                    class="toggle-btn expense"
                    :class="{ active: mainTab === 'expense' }"
                    @click="mainTab = 'expense'; subTab = 'all'"
                >
                    <van-icon name="arrow-down" />
                    {{ getLabel('pageMoneybag.expenseTab', 'Gastos') }}
                </button>
            </nav>

            <!-- 子分类 Tab -->
            <nav class="sub-tabs">
                <button
                    v-for="tab in subTabs"
                    :key="tab.key"
                    type="button"
                    class="sub-tab"
                    :class="{ active: subTab === tab.key }"
                    @click="subTab = tab.key"
                >
                    {{ tab.label }}
                </button>
            </nav>

            <!-- 交易卡片 -->
            <section v-if="filteredList.length" class="bill-list">
                <article
                    v-for="item in filteredList"
                    :key="item.id || item.time"
                    class="bill-card"
                >
                    <div class="card-head">
                        <div class="card-head-left">
                            <span class="bill-icon" :class="mainTab">
                                <van-icon :name="mainTab === 'income' ? 'arrow-up' : 'arrow-down'" />
                            </span>
                            <div class="card-title">
                                <h3>{{ getBillTitle(item) }}</h3>
                                <small>{{ getLabel('pageMoneybag.completed', 'Completado') }}</small>
                            </div>
                        </div>
                        <strong class="amount" :class="mainTab">{{ amountText(item) }}</strong>
                    </div>

                    <div class="balance-rows">
                        <div class="balance-row">
                            <span class="balance-label">{{ getLabel('pageMoneybag.before', 'Antes') }}</span>
                            <b>{{ formatCurrency(beforeBalance(item)) }}</b>
                        </div>
                        <div class="balance-row">
                            <span class="balance-label">{{ getLabel('pageMoneybag.after', 'Después') }}</span>
                            <b>{{ formatCurrency(afterBalance(item)) }}</b>
                        </div>
                    </div>

                    <div class="card-dates">
                        <span>{{ item.time || "--" }}</span>
                        <span>{{ shortDate(item.time) }}</span>
                    </div>

      
                </article>
            </section>

            <div v-else class="empty-state">
                <van-icon name="notes-o" />
                <p>{{ getLabel('pageMoneybag.empty', '暂无账单记录') }}</p>
            </div>
        </main>
    </div>
</template>

<script>
import Vue from "vue";
import Fetch from "../../utils/fetch";
import { Icon } from "vant";

Vue.use(Icon);

export default {
    name: "moneybag",
    data() {
        return {
            lang: this.$i18n.locale || "zh_cn",
            mainTab: "income",
            subTab: "all",
            funds: 0,
            allList: [],
            reasonTextMap: {
                1: this.$t("user.recharge"),
                2: this.$t("user.withdraw"),
                3: this.getLabel("pageMoneybag.reasonGift", "赠送"),
                4: this.$t("index.sign"),
                5: this.getLabel("pageMoneybag.reasonShare", "分享收益"),
                6: this.$t("item.navSubscription"),
                7: this.getLabel("pageMoneybag.reasonRedPacket", "红包"),
                8: this.getLabel("pageMoneybag.reasonReward", "奖励"),
                9: this.getLabel("pageMoneybag.reasonBenefit", "福利"),
                10: this.getLabel("pageMoneybag.reasonInvite", "邀请收益"),
                11: this.$t("utils.income"),
            },
            appOriginalStyles: null,
            bodyOriginalBackground: "",
        };
    },
    computed: {
        subTabs() {
            if (this.mainTab === "expense") {
                return [
                    { key: "all", label: this.getLabel('item.all', 'Todos') },
                    { key: "alquiler", label: this.getLabel('pageMoneybag.catRent', 'Pago de Alquiler') },
                ];
            }
            return [
                { key: "all", label: this.getLabel('item.all', 'Todos') },
                { key: "ganancias", label: this.getLabel('pageMoneybag.catProfit', 'Ganancias') },
                { key: "devolucion", label: this.getLabel('pageMoneybag.catCapital', 'Devolución de capital') },
                { key: "recompensa", label: this.getLabel('pageMoneybag.catReward', 'Recompensa') },
            ];
        },
        filteredList() {
            return this.allList.filter((item) => {
                const isIncome = String(item.type) === "1";
                if (this.mainTab === "income" && !isIncome) return false;
                if (this.mainTab === "expense" && isIncome) return false;
                if (this.subTab !== "all" && this.itemCategory(item) !== this.subTab) return false;
                return true;
            });
        },
    },
    created() {
        this.$parent.footer("user", false);
    },
    mounted() {
        this.applyFullScreenLayout();
        this.start();
    },
    beforeDestroy() {
        this.restoreFullScreenLayout();
    },
    methods: {
        getLabel(key, defaultText) {
            return this.$te(key) ? this.$t(key) : defaultText;
        },
        applyFullScreenLayout() {
            const app = document.getElementById("app");
            if (!app) {
                return;
            }
            this.appOriginalStyles = {
                maxWidth: app.style.maxWidth,
                width: app.style.width,
                margin: app.style.margin,
                backgroundColor: app.style.backgroundColor,
                paddingBottom: app.style.paddingBottom,
            };
            this.bodyOriginalBackground = document.body.style.background;
            app.style.maxWidth = "100%";
            app.style.width = "100%";
            app.style.margin = "0";
            app.style.backgroundColor = "#05070f";
            app.style.paddingBottom = "0";
            document.body.style.background = "#05070f";
        },
        restoreFullScreenLayout() {
            const app = document.getElementById("app");
            if (app && this.appOriginalStyles) {
                app.style.maxWidth = this.appOriginalStyles.maxWidth || "";
                app.style.width = this.appOriginalStyles.width || "";
                app.style.margin = this.appOriginalStyles.margin || "";
                app.style.backgroundColor = this.appOriginalStyles.backgroundColor || "";
                app.style.paddingBottom = this.appOriginalStyles.paddingBottom || "";
            }
            document.body.style.background = this.bodyOriginalBackground || "";
        },
        async start() {
            const res = await Fetch("/user/funds");
            this.funds = Number(res.data.money || 0);
            this.allList = Array.isArray(res.data.list) ? res.data.list : [];
        },
        itemCategory(item) {
            const reasonId = Number(item.reason_id || item.reason || 0);
            const isIncome = String(item.type) === "1";
            if (!isIncome) {
                // 支出
                if (reasonId === 6) return "alquiler";
                return "other";
            }
            // 收入
            if (reasonId === 11) return "ganancias";
            if (reasonId === 8) return "recompensa";
            if (reasonId === 6) return "devolucion";
            if (reasonId === 5 || reasonId === 10) return "ganancias";
            return "other";
        },
        getBillTitle(item) {
            const cat = this.itemCategory(item);
            if (cat === "ganancias") return this.getLabel('pageMoneybag.catProfit', 'Ganancias');
            if (cat === "devolucion") return this.getLabel('pageMoneybag.catCapital', 'Devolución de capital');
            if (cat === "recompensa") return this.getLabel('pageMoneybag.catReward', 'Recompensa');
            if (cat === "alquiler") return this.getLabel('pageMoneybag.catRent', 'Pago de Alquiler');
            const reasonId = Number(item.reason_id || item.reason || 0);
            return item[this.lang] || item.title || item.name || this.reasonTextMap[reasonId] || this.getLabel("pageMoneybag.navTitle", "Movimiento");
        },
        amountText(item) {
            const money = Number(item.money || 0).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
            return String(item.type) === "1" ? "+" + money : money;
        },
        beforeBalance(item) {
            return Number(item.before_balance || item.before || item.funds_before || item.balance_before || 0);
        },
        afterBalance(item) {
            const explicit = Number(item.after_balance || item.after || item.funds_after || item.balance_after);
            if (explicit) return explicit;
            const money = Number(item.money || 0);
            return String(item.type) === "1" ? this.beforeBalance(item) + money : this.beforeBalance(item) - money;
        },
        shortDate(value) {
            if (!value) return "--";
            const str = String(value);
            return str.length >= 10 ? str.slice(0, 10) : str;
        },
        formatCurrency(value) {
            return Number(value || 0).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        },
    },
};
</script>

<style lang="less" scoped>
.moneybag-page {
    min-height: 100vh;
    background: #05070f;
    color: #fff;
}

.top-nav {
    position: sticky;
    top: 0;
    z-index: 50;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 56px;
    padding: 0 16px;
    background: rgba(5, 7, 15, 0.9);
    backdrop-filter: blur(12px);
}

.back-btn {
    position: absolute;
    left: 16px;
    top: 50%;
    width: 30px;
    height: 30px;
    margin-top: -15px;
    padding: 0;
    border: 1px solid rgba(90, 130, 200, 0.3);
    border-radius: 50%;
    background: rgba(20, 35, 65, 0.6);
    color: #cdd8ee;
    display: flex;
    align-items: center;
    justify-content: center;
}

.back-btn .van-icon { font-size: 18px; }

.nav-title {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    color: #eef3ff;
}

.page-content {
    width: 100%;
    max-width: 430px;
    margin: 0 auto;
    padding: 14px 14px 40px;
    box-sizing: border-box;
}

/* ---------- 主切换 ---------- */
.main-toggle {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    margin-bottom: 14px;
}

.toggle-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: 44px;
    border: 1px solid rgba(70, 110, 190, 0.3);
    border-radius: 10px;
    background: rgba(12, 24, 46, 0.6);
    color: #8a9bb8;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
}

.toggle-btn .van-icon { font-size: 16px; }

.toggle-btn.income.active {
    background: linear-gradient(90deg, #2fd0e6, #27b6d6);
    border-color: #2fd0e6;
    color: #04222b;
    box-shadow: 0 0 16px rgba(45, 208, 230, 0.4);
}

.toggle-btn.expense.active {
    background: linear-gradient(90deg, #ff9a2e, #ff7a1a);
    border-color: #ff9a2e;
    color: #2b1503;
    box-shadow: 0 0 16px rgba(255, 154, 46, 0.4);
}

/* ---------- 子分类 Tab ---------- */
.sub-tabs {
    display: flex;
    gap: 8px;
    margin-bottom: 16px;
    overflow-x: auto;
    padding-bottom: 2px;
}

.sub-tabs::-webkit-scrollbar { display: none; }

.sub-tab {
    flex: 0 0 auto;
    height: 34px;
    padding: 0 14px;
    border: 1px solid rgba(70, 110, 190, 0.3);
    border-radius: 999px;
    background: rgba(12, 24, 46, 0.6);
    color: #8a9bb8;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
    cursor: pointer;
}

.sub-tab.active {
    background: rgba(45, 208, 230, 0.18);
    border-color: #2fd0e6;
    color: #2fd0e6;
}

/* ---------- 交易卡片 ---------- */
.bill-list {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.bill-card {
    position: relative;
    padding: 14px;
    border: 1px solid rgba(70, 110, 190, 0.3);
    border-radius: 14px;
    background: rgba(10, 20, 40, 0.7);
    overflow: hidden;
}

.card-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 14px;
}

.card-head-left {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
}

.bill-icon {
    flex: 0 0 36px;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.bill-icon.income {
    background: rgba(45, 208, 230, 0.15);
    color: #2fd0e6;
}

.bill-icon.expense {
    background: rgba(255, 154, 46, 0.15);
    color: #ff9a2e;
}

.bill-icon .van-icon { font-size: 18px; }

.card-title { min-width: 0; }

.card-title h3 {
    margin: 0;
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.3;
}

.card-title small {
    color: #6b7d9c;
    font-size: 10px;
}

.amount {
    flex-shrink: 0;
    font-size: 16px;
    font-weight: 800;
}

.amount.income { color: #2fd0e6; }
.amount.expense { color: #ff9a2e; }

/* ---------- 余额行 ---------- */
.balance-rows {
    margin-bottom: 12px;
}

.balance-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 7px 0;
    border-bottom: 1px solid rgba(70, 110, 190, 0.18);
}

.balance-label {
    color: #6b7d9c;
    font-size: 11px;
}

.balance-row b {
    color: #c5cfe4;
    font-size: 13px;
    font-weight: 600;
}

/* ---------- 日期 ---------- */
.card-dates {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #5a6b8c;
    font-size: 10px;
}

/* ---------- 装饰 ---------- */
.deco-avatar {
    position: absolute;
    right: 14px;
    top: 48px;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    border: 2px solid rgba(255, 255, 255, 0.2);
    background: radial-gradient(circle at 35% 30%, #ffd0a0, #c45a8a 50%, #4a1a4a);
    opacity: 0.85;
}

.deco-wheel {
    position: absolute;
    right: 44px;
    top: 52px;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: conic-gradient(
        #ffd25e 0 30deg, #ff6b6b 30deg 60deg,
        #4ecdc4 60deg 90deg, #6c5ce7 90deg 120deg,
        #ffd25e 120deg 150deg, #ff6b6b 150deg 180deg,
        #4ecdc4 180deg 210deg, #6c5ce7 210deg 240deg,
        #ffd25e 240deg 270deg, #ff6b6b 270deg 300deg,
        #4ecdc4 300deg 330deg, #6c5ce7 330deg 360deg
    );
    opacity: 0.85;
}

/* ---------- 空状态 ---------- */
.empty-state {
    padding: 80px 20px;
    text-align: center;
    color: rgba(255, 255, 255, 0.34);
}

.empty-state .van-icon {
    font-size: 48px;
    color: rgba(45, 208, 230, 0.35);
}

.empty-state p {
    margin: 14px 0 0;
    font-size: 14px;
}
</style>
